const $ = window.$
import React, {useMemo} from "react"
import {createRoot} from "react-dom/client"
import {Provider} from 'react-redux'
import SpinnerSvg from "images/spinner.svg"

const FANCYBOX_PARAMS = {
  'openEffect'  : 'fade',
  'closeEffect' : 'fade',
  'helpers' :  {
    'thumbs' : {
      'width' : 100,
      'height'  : 100
    }
  },
}

// Register a callback to run immediately if page is already loaded, or on DOMContentLoaded if it's
// not already ready. Use as a replacement for old jquery style `$(fn)` "page-ready" logic.
export function onPageReady(fn) {
  if (document.readyState === "complete" || document.readyState === "loaded" || document.readyState === "interactive") {
    fn()
  } else {
    window.addEventListener("DOMContentLoaded", fn)
  }
}

export function LoadingWrapper({loading, children}) {
  return <div className="loading_wrapper">
    <div className="contents">{children}</div>
    <div className={classNames("loading_overlay", {loading: loading})}>
      <div className="loading-spinner"><SpinnerSvg /></div>
    </div>
  </div>
}

export function LinkFormattedText({className, children}) {
  const formattedContent = useMemo(() => {
    const urlPat = /(https?:\/\/[\w.\-/#?=&]*(?=([\s\n\r]|$)))/g
    return children.split(urlPat).filter(match => (match.trim() !== "")).map((chunk, idx) => {
      if (chunk.substring(0, 4) === 'http'){
        return <a key={idx} href={chunk} target="_blank">{chunk}</a>
      } else {
        return <FormattedText key={idx}>{chunk}</FormattedText>
      }
    })
  }, [children])

  return <span className={classNames("formatted_text_line", className)}>{formattedContent}</span>
}

export function FormattedText({className, children}) {
  const formattedContent = useMemo(() => children.replace(/(?:\r\n|\r|\n)/g, '<br/>').split("<br/>").map(
    (line, idx) => <span key={idx} className="formatted_text_line">{line}<br /></span>
  ), [children])

  return <span className={classNames(className)}>{formattedContent}</span>
}

export class ImageExpander extends React.Component {
  componentDidMount(){
    if (window.cm.fancyboxWidget){
      if ($.fancybox.update){
        $.fancybox.update()
      } else {
        this.startFancybox()
      }
    } else {
      window.cm.fancyboxWidget = {
        initiated: true
      }
      this.startFancybox()
    }
  }

  startFancybox(){
    const fancyboxParams = window.cm.fancyboxParams || FANCYBOX_PARAMS
    $('[data-fancybox]').fancybox(fancyboxParams)
  }

  render(){
    const permitDownload = window.cm.studiosUser?.isStaff
    const imageGroup = (this.props.imageGroup || "").toString().replace(":", "-")  // cleaning illegal chars
    return <div className={classNames("image_expander_overlay", {[this.props.className]: this.props.className, "multi-action": permitDownload && this.props.downloadHref})}>
      <a data-fancybox rel={imageGroup} className="icon-resize-full" title="Expand image" href={this.props.href} data-track-event-sp="click_expand_image*browse"></a>
      {permitDownload && this.props.downloadHref && <a className="image_expander_download" title="Download image" href={this.props.downloadHref}></a>}
    </div>
  }
}


export class SimpleImageExpander extends React.Component {
  componentDidMount(){
    if (window.cm.fancyboxWidget){
      if ($.fancybox.update){
        $.fancybox.update()
      } else {
        this.startFancybox()
      }
    } else {
      window.cm.fancyboxWidget = {
        initiated: true
      }
      this.startFancybox()
    }
  }

  startFancybox(){
    const fancyboxParams = window.cm.fancyboxParams || FANCYBOX_PARAMS
    $('[data-fancybox]').fancybox(fancyboxParams)
  }

  render(){
    let props = Object.assign({}, this.props)
    let imageGroup = props.imageGroup || ""
    imageGroup = imageGroup.toString()
    imageGroup = imageGroup.replace(":", "-")  // cleaning illegal chars
    delete props.imageGroup
    return (
      <img data-fancybox rel={imageGroup} data-track-event-sp="click_expand_image*browse" {...props} />
    )
  }
}

export class CustomerImageExpander extends React.Component {
  componentDidMount(){
    $('[data-fancybox]').fancybox({
      openEffect : 'fade',
      closeEffect: 'fade',
      helpers:  {
        thumbs: { width: 100, height : 100 }
      }
    })
  }

  render(){
    let imageGroup = this.props.imageGroup || ""
    imageGroup = imageGroup.toString()
    imageGroup = imageGroup.replace(":", "-")  // cleaning illegal chars
    return <a
      data-fancybox
      rel={imageGroup}
      className={classNames("image-expander-overlay",  {[this.props.className]: this.props.className})}
      href={this.props.href}
      data-track-event-sp="click_expand_image*browse">
      {this.props.children}
    </a>
  }
}

export function mountModal(modal){
  let wrapper = document.querySelector('#modal_wrapper')
  if (!wrapper) {
    wrapper = document.createElement('div')
    wrapper.id = 'modal_wrapper'
    document.body.appendChild(wrapper)
  }
  const rootNode = document.createElement('div')
  wrapper.appendChild(rootNode)
  createRoot(rootNode).render(<Provider store={window.cm.store}>{modal}</Provider>)

  return rootNode
}

export class VideoExpander extends React.Component {
  componentDidMount(){
    if (window.cm.fancyboxWidget){
      if ($.fancybox.update){
        $.fancybox.update()
      } else {
        this.startFancybox()
      }
    } else {
      window.cm.fancyboxWidget = {
        initiated: true
      }
      this.startFancybox()
    }
  }

  startFancybox(){
    const fancyboxParams = window.cm.fancyboxParams || FANCYBOX_PARAMS
    $('[data-fancybox]').fancybox(fancyboxParams)
  }

  render(){
    let classNames = this.props.className ? "image_expander_overlay multi-action" + this.props.className : "image_expander_overlay multi-action"
    const imageGroup = (this.props.imageGroup || "").toString().replace(":", "-")  // cleaning illegal chars
    return (
      <div className={classNames}>
        <a data-fancybox onClick={this.openVideo} rel={imageGroup} className="icon-play image_expander_play" href={this.props.url} data-fancybox-type="iframe" data-track-event-sp="click_expand_video*browse">
          <img className="attachment-thumbnail-hidden" src={this.props.thumbUrl} alt="Video thumbnail" />
        </a>
      </div>)
    }
  }


export class CustomerVideoExpander extends React.Component {
  componentDidMount(){
    $('[data-fancybox]').fancybox({
      openEffect : 'fade',
      closeEffect: 'fade',
      helpers:  {
        thumbs: { width: 100, height : 100 }
      }
    })
  }

  render(){
    let imageGroup = this.props.imageGroup || ""
    imageGroup = imageGroup.toString()
    imageGroup = imageGroup.replace(":", "-")  // cleaning illegal chars
    return <a
      data-fancybox
      rel={imageGroup}
      className={classNames("image-expander-overlay",  {[this.props.className]: this.props.className})}
      href={this.props.href}
      data-fancybox-type="iframe"
      data-track-event-sp="click_expand_video*browse">
        <img className="attachment-thumbnail-hidden" src={this.props.thumbUrl} alt="Video thumbnail" />
        {this.props.children}
    </a>
  }
}


  /**
   * Get cursor position of a text area
   */
  export function getCursorPosition(input) {
      return input.selectionStart
  }

/**
 * easily specify conditional class names. Takes arbitrary number of arguments. Arguments can be
 * strings, arrays, or objects. Strings are kept as-is. Any truthy members of arrays are kept.
 * Objects keys with truthy values are kept. The kept values are combined into a single
 * space-separated string.
 *
 * classNames('foo bar', { baz: true, buzz: false }) => 'foo bar baz'
 * classNames({ baz: true, buzz: false }) => 'baz'
 */
export function classNames() {
  function cssClassFromArray(arr) {
    return arr.filter(x => x).join(" ").trim()
  }

  function cssClassFromObj(obj) {
    return Object.keys(obj).filter(k => obj[k]).join(" ")
  }

  const components = []
  for (const arg of arguments) {
    if (typeof arg === 'string') {
      components.push(arg)
    } else if (arg && typeof arg === 'object') {
      if (Array.isArray(arg)) {
        components.push(cssClassFromArray(arg))
      } else {
        components.push(cssClassFromObj(arg))
      }
    } else if (arg !== undefined && arg !== null) {
      throw `classNames supports strings and objects, but you passed ${arg} with type ${typeof arg}`
    }
  }

  return components.join(" ").trim()
}

/* Wraps a click handler & calls it when the enter or space key is pressed. This emulates default
 * browser behavior with <button>s. Only use this on `role=button` elements that do not by default
 * support keyboard interaction from the browser. I.e. use this on `<div role=button>`, but not
 * `<a>` or `<button>`.
 */
export function keyActivationHandler(clickHandler) {
  return function(keyEv) {
    if(keyEv.key === " " || keyEv.key === "Enter") {
      keyEv.preventDefault()
      clickHandler(keyEv)
    }
  }
}
